// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"f22c2c75","193":"621069c4","670":"d136a957"}[chunkId] + ".chunk.js";
};